
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from 'react';

import Blocks from '../components/blocks/Blocks';
import Footer from '../components/Footer/Footer';
import { useQuery } from '../hooks/useQuery';
import Layout from '../layouts/default';
import { PAGE_QUERY } from '../queries/PAGE_QUERY.gql';
import { cmsDataService } from '../services/cms-data-service';

const Page = ({ preview, uri }) => {
  const { loading, error, data } = useQuery(PAGE_QUERY, {
    variables: {
      uri,
    },
  });

  if (error) return <p>Error...</p>;
  if (!data && loading) return <p>Loading</p>;

  const {
    typeHandle,
    title,
    image,
    subTitle,
    headerText,
    linkTitle,
    ctaUrl,
    linkTitle2,
    ctaUrl2,
    blocks,
    languageSwitch,
  } = data.entry;

  const meta = {
    ...data.entry.customHeadMeta,
  };

  const headerData = {
    typeHandle,
    title,
    image,
    subTitle,
    headerText,
    linkTitle,
    ctaUrl,
    linkTitle2,
    ctaUrl2,
  };

  const { navigation, openingHours } = data.globalSet;

  return (
    <Layout
      meta={meta}
      languageSwitch={languageSwitch}
      navigation={navigation}
      headerData={headerData}
      preview={preview}
    >
      <div className="content">{blocks && <Blocks blocks={blocks} />}</div>
      <Footer openingHours={openingHours} />
    </Layout>
  );
};

 async function _getStaticProps(ctx) {

  // nasty trick to turn multiple segments (captured by [...slug]) into a single url/slug
  // e.g. { slug: [ 'the-gym', 'personal-training' ] } -> the-gym/personal-training
  const slug = ctx.params.slug.toString().replace(/,/g, '/');

  // build queries
  const queries = [
    {
      query: PAGE_QUERY,
      variables: { uri: slug },
    },
  ];

  // construct the url for the redirector
  let url = process.env.siteUrl + '/';
  if(ctx.locale === 'nl'){
    url = process.env.siteUrl + '/nl/'
  }
  url += slug

  // wait for page data
  const pageProps = await cmsDataService.getPageProps({ ctx, queries, url });

  return {
    ...pageProps,
    revalidate: 20,
  };
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}

export default Page;


    export async function getStaticProps(ctx) {
        let res = _getStaticProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/[...slug]',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              
            }))
          }
        }
    }
  